<template>
  <div class="messages-view">
    <PageTitle title="Messages" />

    <v-list class="messages-view__list pt-0">
      <div v-for="(message, idx) in messages" :key="message.id || idx" class="messages-view__item">
        
          <div
            class="messages-view__row"
            @click.stop="openMessageModal(message)"
          >
            
            <div class="messages-view__header">
              <span class="messages-view__badge-wrap">
                <v-badge
                  class="messages-view__badge"
                  color="primary"
                  dot
                  location="start"
                  offset-x="-5"
                  offset-y="15"
                  :model-value="!message.read_at"
                >
                  <span class="messages-view__badge-anchor"></span>
                </v-badge>
              </span>
              <span class="messages-view__subject">
                {{ message.subject }}
                <span class="messages-view__preview" v-html="message.message"></span>
              </span>
              <span class="messages-view__date">{{ findSendDifference(message.delivered_at) }}d</span>
            </div>
            
          </div>
        
        <v-divider class="messages-view__divider"></v-divider>
      </div>
      <div v-if="messages.length === 0" class="text-center pt-3 text-body-2">
        You have not received any messages...
      </div>
    </v-list>

    <v-dialog
      v-model="dialog"
      color="primary"
      fullscreen
      :scrim="false"
      transition="dialog-bottom-transition"
    >
      <v-card class="messages-view__dialog-card">
        <v-card-title class="d-flex messages-view__dialog-title">
          <v-btn
            class="ms-n4 me-1"
            icon
            color="primary"
            size="32"
            variant="text"
            @click="closeMessageModal"
          >
            <icon height="14" width="14">close-x</icon>
          </v-btn>
          <h4 class="flex-grow-1">Message</h4>
        </v-card-title>
        <v-card-text class="pt-5 messages-view__dialog-body">
          <h4 class="mb-5 messages-view__dialog-subject">{{ openMessage.subject }}</h4>
          <div v-if="openMessage.image" class="messages-view__dialog-image-wrap">
            <img :src="openMessage.image" class="messages-view__dialog-image" alt="" />
          </div>
          <p class="text-body-1 grey-text" v-html="openMessage.message"></p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PageTitle from '@/components/shared/PageTitle/index.vue';
import moment from 'moment';

export default {
  name: 'Messages',
  components: {
    PageTitle
  },
  data() {
    return {
      dialog: false,
      openMessage: {
        subject: null,
        message: null,
        image: null
      }
    };
  },
  computed: {
    ...mapState(['offer', 'partnerUser']),
    ...mapGetters('messages', { messages: 'list' })
  },
  methods: {
    ...mapActions('messages', ['getMessages', 'setMessageRead']),
    findSendDifference(value) {
      return moment()
        .subtract(moment().utcOffset(), 'minutes')
        .diff(moment(value), 'days');
    },
    closeMessageModal() {
      this.dialog = false;
      this.openMessage = {
        subject: null,
        message: null,
        image: null
      };
    },
    async openMessageModal(message) {
      this.dialog = true;
      this.openMessage = message;
      if (!message.read_at && this.partnerUser?.id) {
        await this.setMessageRead({
          partnerUser: this.partnerUser.id,
          message,
          params: {
            read: true
          }
        });
      }
    }
  },
  mounted() {
    if (!this.partnerUser?.id || !this.offer?.id) return;

    this.getMessages({
      partnerUser: this.partnerUser.id,
      params: {
        offerId: this.offer.id
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.messages-view__list {
  padding: 0;
}

.messages-view__item {
  list-style: none;
  min-width: 0;
}

.messages-view__badge-wrap {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  line-height: 1;
  font-size: 0.01rem;
  min-height: 1em;
  padding-top: 10px;
  padding-right: 5px;
}

:deep(.v-badge--dot .v-badge__badge) {
  width: 8px;
  height: 8px;
  min-width: 8px;
  padding: 0;
  border-radius: 4px;
}

.messages-view__badge-anchor {
  display: inline-block;
  width: 0px;
  height: 1.25em;
  vertical-align: middle;
}

:deep(.messages-view__badge) {
  min-width: 0;
}

:deep(.messages-view__badge .v-badge__wrapper) {
  min-width: 0;
}

.messages-view__row {
  cursor: pointer;
  min-width: 0;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.messages-view__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  // gap: 12px;
  width: 100%;
  min-width: 0;
}

.messages-view__subject {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.25;
  color: rgba(var(--v-theme-on-surface), 0.92);
  flex: 1;
  min-width: 0;
  padding-right: 12px;
}

.messages-view__date {
  font-size: 0.8125rem;
  color: rgba(var(--v-theme-on-surface), 0.6);
  flex-shrink: 0;
}

.messages-view__preview {
  font-size: 0.8125rem;
  line-height: 1.35;
  color: rgba(var(--v-theme-on-surface), 0.7);
  width: 100%;
  min-width: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  font-weight: 100;
}

:deep(.messages-view__preview p),
:deep(.messages-view__preview div) {
  margin: 0 0 0.25em 0;
  display: block;
}

:deep(.messages-view__preview p:last-child),
:deep(.messages-view__preview div:last-child) {
  margin-bottom: 0;
}

:deep(.messages-view__divider) {
  border-color: rgba(0, 0, 0, 0.85);
}

.messages-view__dialog-card {
  overflow-y: auto;
}

.messages-view__dialog-title {
  flex-wrap: nowrap; 
  font-size: 1.1rem;
}

.messages-view__dialog-body {
  height: calc(100vh - 64px);
}

.messages-view__dialog-image-wrap {
  margin: 20px 0;
}

.messages-view__dialog-image {
  width: 100%;
  display: block;
}

:deep(.v-dialog--fullscreen) {
  box-shadow: none !important;
}

:deep(.v-btn--icon.v-btn--density-default) {
  height: 32px;
  width: 32px;
}
:deep(.v-card-title) {
  height: 64px;
  border-bottom: solid 1px #e0e0e0;
  padding: 16px 24px 10px;
}

.v-card-title h4 {
    font-size: 1.125rem !important;
    line-height: 1.375rem !important;
    margin-top: 6px;
}

.messages-view__dialog-subject {
  color: rgba(var(--v-theme-on-surface), 0.6) !important;
  font-size: 1.125rem !important;
}
.grey-text {
  color: rgba(var(--v-theme-on-surface), 0.6) !important;
}
</style>
